<script>
import axios from '@/utils/axios';
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Quotations",
    quotation: [],
    admin: [],
    banks: [],
  };
},

computed: {

},

mounted() {
 const public_token = this.$route.params.public_token;
 this.quotationByToken(public_token);
},

methods: {

 async quotationByToken(public_token){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.get(`quotations/${public_token}`);
   this.quotation = response.data.data;
   if(this.quotation?.admin_id){
    this.adminDetail(this.quotation.admin_id);
    this.adminBanks(this.quotation.admin_id);
   }
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 isExpired(){
  if(this.quotation?.valid_until){
   const validUntil = new Date(this.quotation.valid_until);
   if(this.quotation.valid_until.length === 10){
    validUntil.setHours(23, 59, 59, 999);
   }
   const now = new Date();
   return ( now > validUntil && this.quotation.status !== 'Accepted' && this.quotation.status !== 'Rejected' );
  }
  return false;
 },

 async downloadPDF(module, id){
  await downloadPDFUtil(module, id);
 },

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<template>
  <div class="content">

    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3">
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        <span class="badge bg-danger me-3" v-if="isExpired()">Expired</span>
        <span class="badge bg-warning p-2 me-3">{{ quotation.status }}</span>
        <a href="javascript:void(0);" class="btn btn-dark align-items-center me-3" @click="downloadPDF('quotations', quotation.id)">
          <i class="ti ti-download me-2"></i>Download
        </a>
        <div class="dropdown" v-if="!isExpired() && (quotation.status !== 'Accepted' && quotation.status !== 'Rejected')">
          <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
            <i class="ti ti-grip-vertical me-2"></i> Action
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_action" @click="$refs.quotationModal.quotationAction(quotation?.id, 'Accepted')"><i class="ti ti-check me-2"></i> Accept</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_action" @click="$refs.quotationModal.quotationAction(quotation?.id, 'Rejected')"><i class="ti ti-x me-2"></i>Reject</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div id="watermark">
      <img :src="admin.company?.watermark_url || admin.company?.logo_url" alt="Watermark">
    </div>

    <!-- Quotation Page -->
    <div style="width:210mm; min-height:297mm; margin:auto; background:#fff; border:1px solid #ccc; box-shadow:0 2px 12px rgba(0,0,0,0.10); font-family:'Segoe UI',Arial,sans-serif; font-size:13px; color:#333;">

      <!-- Title -->
      <div style="background:#2c3e50; color:#fff; text-align:center; font-size:18px; font-weight:700; letter-spacing:3px; padding:12px; text-transform:uppercase;">
        Quotation
      </div>

      <!-- Company Info -->
      <table style="width:100%; border-collapse:collapse;">
        <tr>
          <td style="width:38%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:top;">
            <img :src="admin.company?.logo_url" :alt="admin.company?.company_name" style="width:160px; height:auto; margin-bottom:4px;">
          </td>
          <td style="width:62%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:top; text-align:right; line-height:1.6;">
            <div style="font-size:16px; font-weight:700; color:#2c3e50; margin-bottom:4px;">{{ admin?.company?.company_name }}</div>
            <span v-if="admin.company?.is_iso_certified"  style="display:inline-block; font-size:10px; color:green; border:1px solid green; border-radius:3px; padding:1px 6px; margin-bottom:6px;">ISO 9001:2015 Certified</span><br>
            <span v-if="admin?.company?.gst" style="font-size:12px; color:#555; display:block;">GSTIN: <strong style="color:#333;">{{ admin?.company?.gst }}</strong></span>
            <span style="font-size:12px; color:#555; display:block;"><strong style="color:#333;">Email:</strong> {{ admin?.company?.email }}</span>
            <span style="font-size:12px; color:#555; display:block;"> <strong style="color:#333;">Address:</strong>  {{ admin?.company?.address }} {{ admin?.company?.city }}, {{ admin?.company?.state }} {{ admin?.company?.country }} - {{ admin?.company?.pincode }}</span>
            <span v-if="admin?.company?.mobile" style="font-size:12px; color:#555; display:block;"><strong style="color:#333;">Phone:</strong>  {{ admin?.company?.mobile }}</span>
          </td>
        </tr>
      </table>

      <!-- Client + Quotation Meta -->
      <table style="width:100%; border-collapse:collapse;">
        <tr>
          <td style="width:50%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:top; font-size:12px; line-height:1.7;">
            <p style="margin:0;"><strong>Name:</strong> {{ quotation.to_name }}</p>
            <p style="margin:0;" v-if="quotation.to_pincode"><strong>Address:</strong> {{ quotation.to_address }}, {{ quotation.to_city }}, {{ quotation.to_state }}, {{ quotation.to_country }} - {{ quotation.to_pincode }}</p>
            <p style="margin:0;" v-if="quotation.to_email"><strong>Email:</strong> {{ quotation.to_email }}</p>
            <p style="margin:0;" v-if="quotation.to_phone"><strong>Phone:</strong> {{ quotation.to_phone }}</p>
            <p style="margin:0;" v-if="quotation.gst_no"><strong>GSTIN:</strong> {{ quotation.gst_no }}</p>
          </td>
          <td style="width:50%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:top; font-size:12px; line-height:1.7; background:#fafafa;">
            <p style="margin:0;"><strong>Quotation No:</strong> {{ quotation?.quotation_number }}</p>
            <p style="margin:0;"><strong>Date:</strong> {{ $formatDate(quotation?.quotation_date, 'DD MMM YYYY') }}</p>
            <p style="margin:0;"><strong>Sales Person:</strong> {{ quotation?.sales_person?.name }}</p>
            <p style="margin:0;"><strong>Contact:</strong> {{ quotation?.sales_person?.mobile }}</p>
            <p style="margin:0;"><strong>Email:</strong> {{ quotation?.sales_person?.email }}</p>
          </td>
        </tr>
      </table>

      <!-- Subject / Summary -->
      <div style="padding:10px 14px; border:1px solid #e0e0e0; font-size:12px; line-height:1.6;">
        <p style="margin:0 0 3px;"><strong>Subject:</strong> {{ quotation.subject }}</p>
        <div class="dynamic">
          <strong>Summary:</strong>
          <div v-html="quotation.summary"></div>
        </div>
      </div>

      <!-- Items Table -->
<!-- Dimensional Items Table -->
<template v-if="quotation.quotation_items?.filter(r => r.item?.calculation_type === 'dimensional').length">
  <div style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border:1px solid #e0e0e0; margin-top:14px;">
    Dimensional Items
  </div>
  <table style="width:100%; border-collapse:collapse; table-layout: fixed;">
    <thead>
      <tr style="background:#2c3e50; color:#fff;">
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:6%;overflow:hidden;">S.No.</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:25%;">Title</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Image</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">HSN/SAC</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Width (mm)</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Height (mm)</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:7%;">Size</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:6%;">Unit</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Rate</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:6%;">Qty</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:7%;" v-if="quotation.tax_mode === 'Item'">Tax</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in quotation.quotation_items.filter(r => r.item?.calculation_type === 'dimensional')" :key="'d-'+index" :style="index % 2 === 1 ? 'background:#f9f9f9;' : ''">
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px;">{{ index + 1 }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; font-size:12px; line-height:1.5; vertical-align:middle; word-break: break-word; max-width: 200px;">
          <strong>{{ row.name }}</strong>
          <p v-if="row.description" style="margin:0; word-break: break-word;" v-html="row.description"></p>
        </td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; vertical-align:middle;">
          <img v-if="row.item?.image" :src="row.item?.image_url" style="width:70px; height:70px; object-fit:cover; border:1px solid #ddd; border-radius:4px;">
          <i v-else class="ti ti-photo fs-24 text-muted"></i>
        </td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.hsn_code ?? 'N/A' }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.width }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.height }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ parseFloat(row.size).toFixed(2) }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.unit }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.unit_price }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.quantity }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;" v-if="quotation.tax_mode === 'Item'">{{ row?.tax?.name }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ row.total }}</strong></td>
      </tr>
    </tbody>
  </table>
</template>

<!-- Standard Items Table -->
<template v-if="quotation.quotation_items?.filter(r => r.item?.calculation_type !== 'dimensional').length">
  <div style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border:1px solid #e0e0e0; margin-top:14px;">
    Standard Items
  </div>
  <table style="width:100%; border-collapse:collapse;table-layout:fixed;">
    <thead>
      <tr style="background:#2c3e50; color:#fff;">
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:6%;">S.No.</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:28%;">Title</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:9%;">Image</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:9%;">HSN/SAC</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Unit</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Price</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;">Quantity</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:8%;" v-if="quotation.tax_mode === 'Item'">Tax</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:9%;">Sub Total</th>
        <th style="padding:8px 10px; font-size:11.5px; font-weight:600; border:1px solid #3d5166; text-align:center; width:9%;">Final Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in quotation.quotation_items.filter(r => r.item?.calculation_type !== 'dimensional')" :key="'s-'+index" :style="index % 2 === 1 ? 'background:#f9f9f9;' : ''">
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px;overflow:hidden;">{{ index + 1 }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; font-size:12px; line-height:1.5; vertical-align:middle;overflow-wrap:break-word;">
          <strong>{{ row.name }}</strong>
          <p v-if="row.unit" style="margin:0; color:#777; font-size:11px;">Unit: {{ row.unit }}</p>
          <p v-if="row.description" style="margin:0;" v-html="row.description"></p>
        </td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; vertical-align:middle;">
          <img v-if="row.item?.image" :src="row.item?.image_url" style="width:70px; height:70px; object-fit:cover; border:1px solid #ddd; border-radius:4px;">
          <i v-else class="ti ti-photo fs-24 text-muted"></i>
        </td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.hsn_code ?? 'N/A' }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.unit }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ row.taxable_amount }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.quantity }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;" v-if="quotation.tax_mode === 'Item'">{{ row?.tax?.name }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ row.taxable_amount * row.quantity }}</strong></td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ row.total }}</strong></td>
      </tr>
    </tbody>
  </table>
</template>

<!-- Totals -->
<table style="width:100%; border-collapse:collapse;">
  <tfoot>
    <tr>
      <td style="border:1px solid #e0e0e0; padding:0;">
        <div style="text-align:right; padding:12px 14px; font-size:12.5px; line-height:1.9;">
          Sub Total: <strong>{{ quotation.subtotal }}</strong><br>

          <template v-if="quotation.tax_mode === 'Invoice'">
            Tax: {{ quotation.tax.name }}: <strong>{{ quotation.tax_amount }}</strong><br>
          </template>
          <template v-else-if="quotation.tax_mode === 'Item' && quotation.tax_breakdown && Object.keys(quotation.tax_breakdown).length > 0">
            <template v-for="(taxData, taxRate) in quotation.tax_breakdown" :key="taxRate">
              {{ taxData.name }} Tax on {{ parseFloat(taxData.taxable_amount || 0).toFixed(2) }}: <strong>{{ parseFloat(taxData.tax_amount).toFixed(2) }}</strong><br>
            </template>
          </template>
          <template v-else-if="quotation.tax_mode === 'Item'">
            Item Taxes: <strong>{{ quotation.tax_amount }}</strong><br>
          </template>

          <span v-if="quotation.discount !== '0.00'">Discount: <strong>{{ quotation.discount }}</strong><br></span>
          <span v-if="quotation.transportation_cost !== '0.00'">Transportation Cost: <strong>{{ quotation.transportation_cost }}</strong><br></span>
          <span v-if="quotation.installation_cost !== '0.00'">Installation Cost: <strong>{{ quotation.installation_cost }}</strong><br></span>

          <div style="display:inline-block; font-size:14px; font-weight:700; color:#2c3e50; border-top:1px solid #ccc; padding-top:5px; margin-top:3px;">
            Final Amount: {{ `${quotation?.party?.currency.code} ${quotation.total}` }}
          </div><br>
          <span style="font-size:11px; color:#777; font-style:italic;">({{ $amountInWords(quotation.total) }})</span>
        </div>
      </td>
    </tr>
  </tfoot>
</table>

      <!-- Terms -->
      <div v-if="quotation.terms" style="margin-top:14px; border:1px solid #e0e0e0;">
        <div style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border-bottom:1px solid #e0e0e0;">
          Terms &amp; Conditions
        </div>
        <div style="padding:10px 14px; font-size:12px; color:#555; line-height:1.7;" class="dynamic">
          <div v-html="quotation.terms"></div>
        </div>
      </div>

      <!-- Bank Details -->
      <table style="width:100%; border-collapse:collapse; margin-top:14px;">
        <tr>
          <th colspan="3" style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border:1px solid #e0e0e0; text-align:left;">
            Bank Details
          </th>
        </tr>
        <tr>
          <td style="border:1px solid #e0e0e0; padding:10px 14px; width:33%; vertical-align:top; font-size:12px; line-height:1.7;" v-for="row in banks">
            <strong>{{ row.name }}</strong><br>
            A/C Holder: {{ row.account_holder_name }}<br>
            A/C No: {{ row.account_no }}<br>
            IFSC: {{ row.ifsc }}<br>
            Branch: {{ row.branch }}<br>
            <img v-if="row.image" :src="row.image_url" style="width:90px; height:auto; margin-top:6px;">
          </td>
        </tr>
      </table>

      <!-- Notes + Signature -->
      <table style="width:100%; border-collapse:collapse; margin-top:14px; border:1px solid #e0e0e0;">
        <tr>
          <td style="width:70%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:top; font-size:12px; line-height:1.6;">
            <div class="dynamic">
              <strong v-if="quotation.notes">Notes:</strong>
              <div v-html="quotation.notes"></div>
            </div>
          </td>
          <td style="width:30%; padding:12px 14px; border:1px solid #e0e0e0; vertical-align:bottom; text-align:center;">
            <img v-if="admin.company?.signature_url" :src="admin.company?.signature_url" style="width:110px; height:auto; margin-bottom:6px;"><br>
            <div style="width:120px; height:1px; background:#333; margin:0 auto 5px;"></div>
            <strong style="font-size:12px;">Authorised Signatory</strong><br>
            <span style="font-size:11px; color:#666;">On behalf of {{ admin.company?.company_name }}</span>
          </td>
        </tr>
      </table>

    </div>
    <!-- /Quotation Page -->

  </div>

  <quotation-modal ref="quotationModal" @updated="quotationByToken(quotation?.public_token)"></quotation-modal>
</template>